/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * FilterChip CSS
 */

export const styles = css`

  :host{
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .filter-chips {
    display: flex;
    align-items: center;
  }


  .chip {
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 8px;
    border: 1px solid var(--nile-filter-chip-chip-border-color-stroke, var(--ng-colors-border-primary));
    border-radius: var(--nile-radius-sm, var(--ng-radius-md));
    font-size: 14px;
    background-color: var(--nile-filter-chip-background-default, var(--ng-colors-bg-primary));
    color: var(--nile-filter-chip-text-default, var(--ng-colors-text-secondary-700));
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
    cursor: pointer;
    box-sizing: border-box;
  }

  .chip:hover {
    background-color: var(--nile-filter-chip-hover-background, var(--ng-colors-bg-primary-hover));
  }
 .chip:active {
  background-color: var(--nile-filter-chip-active-background, var(--ng-colors-bg-active));
  border-color: var(--nile-filter-chip-active-border-color-stroke);
}
:host([active]) .chip {
  background-color: var(--nile-filter-chip-active-background, var(--ng-colors-bg-active));
  border-color: var(--nile-filter-chip-active-border-color-stroke);
}


  .icon {
    color: var(--nile-filter-chip-icon-color-default, var(--ng-colors-text-primary-900));
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    top: 12px;
  }

  .label {
    font-weight: 500;
    color: var(--nile-filter-chip-label-color-default, var(--ng-colors-text-primary-900));
  }

  nile-badge::part(base) {
    width: auto;
    height: 14px;
    border-radius: 100px;
    padding: 6px;
    gap: 10px;
    font-size: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .chip-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .clear-all-container {
    margin-left: 18px;
    white-space: nowrap;
    cursor: pointer;
  }


 .value {
  color: var(--nile-filter-chip-values-color-default, var(--ng-colors-text-brand-secondary-700));
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
  vertical-align: bottom;
}


  .close-icon {
    color: var(--nile-filter-chip-close-icon-color-default, var(--ng-componentcolors-utility-gray-400));
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 50%;
    transition: background-color 0.2s;
  }

  .close-icon:hover {
    background-color: var(--nile-filter-chip-close-icon-hover-background, var(--ng-colors-bg-primary-hover));
    color: var(--nile-filter-chip-close-icon-hover-color, var(--ng-componentcolors-utility-gray-500));
  }

.label-wrapper {
  margin-right: 4px;
}

::slotted([slot="icon"]) {
  margin-right: 6px;
}

.value-wrapper {
  margin-right: 4px; 
}

.badge-wrapper {
  margin-right: 12px;  
}

.badge{
  display: inline-flex;
    align-items: center;
    height: 20px; 
}

nile-badge::part(content) {
 line-height: 20px;
}

:host([disabled]) .chip {
  background-color: var(--nile-colors-white-base, var(--ng-colors-bg-disabled-subtle));
  border-color: var(--nile-colors-neutral-400, var(--ng-colors-border-disabled));
  color: var(--nile-colors-neutral-500, var(--ng-colors-text-secondary-700));
  cursor: not-allowed;
  opacity: var(--nile-opacity-100, var(--ng-opacity-50));
}

:host([disabled]) .label {
  color: var(--nile-colors-neutral-500, var(--ng-colors-text-secondary-700));
  font-family:colfax-regular;
  user-select: none;
  -webkit-user-select: none;
}

:host([disabled]) .value {
  color: var(--nile-colors-primary-500, var(--ng-colors-text-brand-secondary-700));
  user-select: none;
  -webkit-user-select: none;
}

:host([disabled]) nile-badge::part(base) {
  background-color: var(--nile-colors-primary-500,var(--ng-colors-text-brand-secondary-700));
  color: var(--nile-colors-white-base, var(--ng-colors-text-white));
  user-select: none;
  -webkit-user-select: none;
}

`;

export default [styles];

 